export const SET_SUBSCRIPTIONS = 'SET_SUBSCRIPTIONS';

export const setSubscriptions = (subscriptions) => {
    return {
        type: SET_SUBSCRIPTIONS,
        payload: subscriptions
    };
};